import React from 'react';

import { useAsyncEffect } from '@/hooks/useAsyncEffect';
import { NamedIdentified } from '@/types/namedIdentified';

export const useStateCities = (
  country: string | undefined,
  state: string | undefined,
): readonly NamedIdentified[] => {
  const [cities, setCities] = React.useState<readonly NamedIdentified[]>([]);

  const countryKey = React.useMemo((): string => country?.toLowerCase() ?? '', [country]);

  const fetchStateCities = React.useCallback(async (): Promise<readonly NamedIdentified[]> => {
    if (!state) {
      return [];
    }

    const stateKey = state.toLowerCase();
    const response = await fetch(`/countries/${countryKey}/${stateKey}/index.json`);
    const resolved = await response.json();
    if (!resolved) {
      return [];
    }

    return resolved;
  }, [countryKey, state]);

  useAsyncEffect(async (): Promise<void> => {
    const stateCities = await fetchStateCities();
    setCities(stateCities);
  }, [fetchStateCities]);

  return cities;
};
